import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./auth/Auth";
import { PermissionsProvider } from "./auth/PermissionsContext";
import { Toaster } from "./components/ui/toaster";
import { CookiesProvider } from "react-cookie";
import { NuqsAdapter } from "nuqs/adapters/react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const Providers = ({ children }) => {

  return (
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <PermissionsProvider>
            <NuqsAdapter>{children}</NuqsAdapter>
          </PermissionsProvider>
        </AuthProvider>
        <Toaster />
      </QueryClientProvider>
    </CookiesProvider>
  );
};
